<template>
    <Modal :open="displayModal" @close="displayModal = false">
        <div class="w-full bg-white shadow-lg rounded-none md:rounded-lg p-6">

            <div class="w-full relative">
                <h2 class="font-semibold text-gray-900 text-2xl leading-tight border-b-2 border-gray-200 pb-4">Edit Video Details</h2>
                <button class="text-grey-darkest font-bold rounded absolute top-0 right-0 outline-none text-xl absolute" @click="displayModal = false">
                    <i class="fas fa-times"></i>
                </button>
            </div>

            <div class="mt-4">

                <div class="mb-4">
                    <label class="block text-grey-darkest font-bold mb-2" for="title">
                        Title
                    </label>
                    <input class="bg-grey-lighter appearance-none border-2 border-grey-lighter rounded w-full py-2 px-4 text-grey-darker leading-tight focus:outline-none focus:bg-white focus:border-grey-darkest" id="title" type="text" v-model="data.title">
                </div>

                <div class="mb-4">
                    <label class="block text-grey-darkest font-bold mb-2">
                        Description
                    </label>
                    <textarea class="bg-grey-lighter appearance-none border-2 border-grey-lighter rounded w-full py-2 px-4 text-grey-darker leading-tight focus:outline-none focus:bg-white focus:border-grey-darkest" v-model="data.description" rows="10"></textarea>
                </div>

                <div class="mb-4">
                    <label class="block text-grey-darkest font-bold mb-2" for="title">
                        Credit
                    </label>
                    <input class="bg-grey-lighter appearance-none border-2 border-grey-lighter rounded w-full py-2 px-4 text-grey-darker leading-tight focus:outline-none focus:bg-white focus:border-grey-darkest" id="title" type="text" v-model="data.user_credit">
                </div>

                <div class="mb-4">
                    <label class="block text-grey-darkest font-bold mb-2">
                        Rating
                    </label>
                    <div class="w-full flex">
                        <div class="w-1/2">
                            <input class="bg-grey-lighter appearance-none border-2 border-grey-lighter rounded w-full py-2 px-4 text-grey-darker leading-tight focus:outline-none focus:bg-white focus:border-grey-darkest" id="inline-full-name" type="text" v-model="data.rating" placeholder="3.5">
                        </div>
                        <div class="w-1/2 flex justify-center items-center">
                            <StarRating id="starRating" :rating="(data.rating > 5) ? 0 : data.rating" />
                        </div>
                    </div>
                </div>

                <div class="mb-4">
                    <label class="block text-grey-darkest font-bold mb-2">
                        Price
                    </label>
                    <input class="bg-grey-lighter appearance-none border-2 border-grey-lighter rounded w-full py-2 px-4 text-grey-darker leading-tight focus:outline-none focus:bg-white focus:border-grey-darkest" id="inline-full-name" type="number" v-model="data.price">
                </div>

                <div class="mb-4">
                    <label class="block text-grey-darkest font-bold mb-2">
                        Embargo
                    </label>
                    <input class="bg-grey-lighter appearance-none border-2 border-grey-lighter rounded w-full py-2 px-4 text-grey-darker leading-tight focus:outline-none focus:bg-white focus:border-grey-darkest" id="inline-full-name" type="text" v-model="data.embargo">
                </div>

            </div>

            <!-- footer -->
            <div class="mt-10 clearfix">
                <!-- @click="addAnnouncement()" -->
                <button v-on:click="displayModal = false" class="px-4 py-2 text-gray-800 font-semibold bg-white hover:bg-gray-100 border rounded focus:outline-none focus:shadow-outline float-left">
                    Cancel
                </button>
                <button v-on:click="updateVideo" class="px-4 py-2 text-white font-semibold bg-blue-700 hover:bg-blue-800 border border-transparent rounded focus:outline-none focus:shadow-outline float-right">
                    Update Video
                </button>
            </div>

        </div>
        
    </Modal>

</template>

<script>
    import { EventBus } from '@/utils/events'
    import * as Config from '@/config'
    import { mapState, mapGetters } from 'vuex'

    import Modal from '@/components/Modal'
    import StarRating from '@/components/general/StarRating'

    export default {
        data() {
            return {
                displayModal: false,
                data: {},
                newPrice: null,
            }
        },

        components: {
            Modal,
            StarRating
        },

        mounted() {
            this.$nextTick(function () {
                EventBus.$on('admin-edit-video-open-modal', this.open);
            }.bind(this));

            $(this.$refs.vuemodal).on("hidden.bs.modal", this.stopPlayerOnModalClose)
        },

        destroyed() {
            EventBus.$off('admin-edit-video-open-modal', this.open);
        },

        methods: {
             ...mapGetters([
                'getAuthorizationHeader',
            ]),

            close() {
                // this.players[0].destroy();
            },

            open(data) {
                this.displayModal = true
                this.data = data;
                this.newPrice = data.price;
            },

            updateVideo() {

                var _this = this;

                if(this.newPrice !== this.data.price) {

                    this.$swal({
                        title: 'Continue?',
                        text: "Are you sure you want to change the price?",
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Yes, change price.'
                    }).then((result) => {

                        if (result.value) {

                            var data = {
                                id: this.data.id,
                                title: this.data.title,
                                description: this.data.description,
                                price: this.newPrice,
                                embargo: this.data.embargo,
                                rating: this.data.rating,
                                user_credit: this.data.user_credit,
                            }

                            this.$http.post(Config.apiPath + "/api/v2/admin/videos/edit/" + this.data.id, data, this.getAuthorizationHeader()).then((response) => {
                                if(response.status == 200) {

                                    _this.$swal(
                                        'All good!',
                                        'The video details were successfully updated.',
                                        'success'
                                    )

                                    EventBus.$emit('admin-approve-sale-refresh-data');
                                    _this.displayModal = false

                                }

                            });
                        }

                    });

                } else {

                    var data = {
                        id: this.data.id,
                        title: this.data.title,
                        description: this.data.description,
                        embargo: this.data.embargo,
                        user_credit: this.data.user_credit,
                    }


                    this.$http.post(Config.apiPath + "/api/v2/admin/videos/edit/" + this.data.id, data, this.getAuthorizationHeader()).then((response) => {
                        if(response.status == 200) {

                            _this.$swal(
                                'All good!',
                                'The video details were successfully updated.',
                                'success'
                            )

                            EventBus.$emit('admin-edit-video-refresh-data');
                            _this.displayModal = false
                            
                        }

                    });

                }

            },


            getOptions(search, loading) {
                loading(true)

                var data = {
                    name: search,
                }

                this.$http.post(Config.apiPath + '/api/v2/admin/users/search/stringers', data, this.getAuthorizationHeader())
                    .then(response => {
                        this.userCollection = response.data;
                        loading(false)
                    })
            },

        }
        
    }
</script>

<style>
    .video-preview {
        text-align: center;
        color: #495057;
    }
</style>